export enum EHttpStatusCode {
    ok = 200,
    noContent = 204,

    badRequest = 400,
    unauthorized = 401,
    forbidden = 403,
    notFound = 404,
    conflict = 409,

    serverError = 500,
}